var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnRename1 = function SvgIcnRename1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-rename",
    transform: "translate(-0.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 16,
    height: 16,
    transform: "translate(0.4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drive_file_rename_outline_FILL0_wght400_GRAD-25_opsz20",
    d: "M6.574,13.181l2.384-2.4h4.77v2.4ZM2.922,11.988h.83l5.1-5.1-.83-.83-5.1,5.1Zm8.453-5.9L8.839,3.536l.694-.695a1.118,1.118,0,0,1,.838-.362,1.167,1.167,0,0,1,.853.362l.845.861a1.1,1.1,0,0,1,.34.845,1.2,1.2,0,0,1-.355.861Zm-.83.815L4.265,13.181H1.729V10.645L8.008,4.366Zm-2.1-.422-.422-.422.83.83Z",
    transform: "translate(0.122 0.204)",
    fill: "#8d8d8d"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnRename1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-rename1.c9aeb154.svg";
export { ForwardRef as ReactComponent };